import { Icon } from "@iconify/react";
import { Button, useMediaQuery } from "@mui/material";
import { useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import AllImagesModal from "./AllImagesModal";
import PostImagesPreview from "./PostImagesPreview";

const baseStyle = {
  display: "flex",
  height: "200px",
  margin: "0px",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  borderWidth: 1,
  borderRadius: 8,
  borderColor: "var(--portal-primary-color)",
  borderStyle: "dashed",
  backgroundColor: "#F8FAFC",
  color: "#162D3D",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "var(--portal-primary-color)",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

export default function PostUploadImages({ previews, setPreviews }) {
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [openAllImagesModal, setOpenAllImagesModal] = useState(false);

  const handleRemoveImage = (index) => {
    setPreviews((prev) => {
      return prev.filter((img, i) => i !== index);
    });
  };

  const handleUpload = async (event) => {
    const fileList = Array.from(event.target.files); // Convert FileList to an array
    setPreviews((prev) => [
      ...prev,
      ...fileList.map((file) => ({
        path: file,
        type: "file",
      })),
    ]);
    event.target.value = "";
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    open,
  } = useDropzone({
    accept: {
      "image/*": [".png", ".gif", ".jpeg", ".jpg"],
    },
    type: "file",
    noClick: true,
    noKeyboard: true,
    onDrop: (acceptedFiles) => {
      let images = [];
      images = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );

      setPreviews((prev) => [
        ...prev,
        ...images.map((file) => ({
          path: file,
          type: "file",
        })),
      ]);
    },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject]
  );

  const handleOpenAllImagesModal = () => {
    setOpenAllImagesModal(true);
  };
  const handleCloseAllImagesModal = () => {
    setOpenAllImagesModal(false);
  };

  return (
    <div>
      <div className="col-md-12 mb-3">
        <AllImagesModal
          open={openAllImagesModal}
          handleClose={handleCloseAllImagesModal}
          imagesList={previews}
          setImagesList={setPreviews}
          handleRemoveImage={handleRemoveImage}
          uploadImagesOnClick={open}
        />

        {previews && previews.length > 0 && (
          <div className="card-ui mb-2 position-relative show-on-hover-parent">
            <PostImagesPreview
              imagesList={previews}
              setImagesList={setPreviews}
              isEditOptions={true}
              uploadImagesOnClick={open}
              openAllImagesModal={handleOpenAllImagesModal}
            />
          </div>
        )}

        <div
          {...getRootProps({
            style: previews.length == 0 ? style : { ...style, display: "none" },
          })}
        >
          <input {...getInputProps()} />
          {lgUp && (
            <div
              style={{
                textAlignLast: "center",
              }}
              className="mb-2"
            >
              <p> {"Drag 'n' drop images here"}</p>
              <p>{"or"}</p>
            </div>
          )}

          <Button
            variant="contained"
            component="label"
            sx={{
              borderRadius: "30px",
            }}
            onClick={open}
          >
            <Icon icon={"icon-park-outline:add-pic"} className="me-2" />

            {"Upload Images"}
          </Button>
        </div>
      </div>
    </div>
  );
}
